<template lang="pug">
.caseAxis
  .Axis-box
    Form(:model="question")
      .Axis-stem
        Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
          @click='showAIDialog()',v-if='enableAI') AI生成
        Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
          Form(:model="aiForm" :label-width="80")
            FormItem(label="生成数量")
              InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
            FormItem(label='提示词',prop="stem")
              Input(v-model='aiForm.system' placeholder='请填写提示词'
                type="textarea" :rows="3")
        FormItem
          Input.input1(type='text',placeholder='请输入题目',v-model='question.stem')
        iDelModel.ide(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      .Axis-metas
        FormItem(v-for='(item,index) in question.metas',
            :label='"#说明"+(index+1)',
            label-position="right",
            :label-width="80",
            :key='index')
          Input(type='text',v-model='question.metas[index]')
          Icon(type="ios-close-circle",@click='cancelOption(index)',style="margin-left:10px")
        FormItem
          Button.button(@click='addOption') + 添加说明
</template>
<script>
import iDelModel from "@/components/common/iDelModel";
import Bus from "../../utils/bus";
export default {
  components: {
    iDelModel
  },
  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      // optionsQuantity: 2, // 选项数量
      // options: [],
      question: {
        stem: "", // 标题
        metas: ["", ""]
      },
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "TEXTAXIS",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
              Bus.$emit("refresh-task", this.taskId);
          } else {
              this.$emit("refresh-query");
          }
        }
      });
    },
    addOption() {
      console.log(this.question.metas.length);
      if (this.question.metas.length < 8) {
        // this.question.metas.length += 1;
        this.question.metas.push("");
      } else {
        this.$Message.error("最多只能存在8个选项");
      }
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    },
    cancelOption(index) {
      console.log(index);
      if (this.question.metas.length > 2) {
        // this.this.question.metas -= 1;
        this.question.metas.splice(index, 1);
      } else {
        this.$Message.error("最少必须保留2个选项");
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
  // watch: {
  //   optionsQuantity() {
  //     this.options = [];
  //     for (let i = 1, len = this.optionsQuantity; i <= len; i++) {
  //       this.options.push(`说明${i}`);
  //     }
  //   }
  // },
  // created() {
  //   for (let i = 1, len = this.optionsQuantity; i <= len; i++) {
  //     this.options.push(`说明${i}`);
  //   }

  // }
};
</script>

<style lang="stylus">
.caseAxis
  .Axis-box
    padding 24px
    .Axis-stem
      position relative
      .ide
        margin-top -10px
      .input1
        width 80%
        float left
      .ivu-form-item-content
        // margin-right 300px
      .btns
        position absolute
        top -5px
        right 0
        .ivu-icon
          color #3A76D2FF
          font-size 22px
          top 0
          margin-right 12px
          background #F2F5FAFF
          width 24px
          height 24px
          border-radius 4px
          text-align center
          line-height @height
          &:hover
            cursor pointer
    .Axis-metas
      .button
        float left
        margin-left 25px
        color #3a76d2
      .ivu-form-item-content
        margin-right 25px
        position relative
        .ivu-icon-ios-close-circle
          font-size 22px
          position absolute
          top 6px
          color #E72020FF
          &:hover
            cursor pointer
</style>
